(() => {
  function init(root=document) {
    root.querySelectorAll('[data-wp26-product]').forEach(product => {
      if(product.dataset.ready) return;
      product.dataset.ready='true';
      product.querySelectorAll('[data-wp26-thumb]').forEach(button=>button.addEventListener('click',()=>{
        product.querySelectorAll('[data-wp26-slide]').forEach(slide=>{
          slide.hidden=slide.dataset.wp26Slide!==button.dataset.wp26Thumb;
          slide.querySelectorAll('video').forEach(video=>{
            if(slide.hidden) video.pause();
            else { video.controls=true; video.play().catch(()=>{}); }
          });
        });
        product.querySelectorAll('[data-wp26-thumb]').forEach(thumb=>thumb.setAttribute('aria-pressed',String(thumb===button)));
      }));
      product.querySelectorAll('.wp26-gallery-demo').forEach(link=>link.addEventListener('click',event=>{
        event.preventDefault();
        const gallery=link.closest('.wp26-gallery');
        const slide=[...gallery.querySelectorAll('[data-wp26-slide]')].find(item=>item.querySelector('video'));
        if(!slide)return;
        const thumb=[...gallery.querySelectorAll('[data-wp26-thumb]')].find(item=>item.dataset.wp26Thumb===slide.dataset.wp26Slide);
        thumb?.click();
      }));
      product.querySelectorAll('input[name="wp26-pack"]').forEach(input=>input.addEventListener('change',()=>{
        if(!input.checked) return;
        product.querySelector('input[name="id"]').value=input.value;
        product.querySelector('[data-wp26-quantity]').value=1;
        product.querySelector('[data-wp26-price]').textContent=input.dataset.total;
        const compare=product.querySelector('[data-wp26-compare]');
        if(compare){compare.textContent=input.dataset.compare;compare.hidden=!input.dataset.compare;}
        const url=new URL(location.href);url.searchParams.set('variant',input.value);history.replaceState({},'',url);
        document.querySelectorAll('[data-wp26-sticky-price]').forEach(node=>node.textContent=input.dataset.total);
      }));
      const sticky=document.querySelector('[data-wp26-sticky]');
      const add=product.querySelector('.wp26-add');
      if(sticky&&add){
        const observer=new IntersectionObserver(entries=>{const entry=entries[0];sticky.hidden=entry.isIntersecting||entry.boundingClientRect.top>0;},{threshold:0});
        observer.observe(add);
        document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(product))observer.disconnect();},{once:true});
      }
      const dialog=document.querySelector('[data-wp26-lightbox]');
      if(dialog){
        product.querySelectorAll('[data-wp26-zoom]').forEach(link=>link.addEventListener('click',event=>{
          if(event.metaKey||event.ctrlKey||event.shiftKey||event.altKey) return;
          event.preventDefault();dialog.querySelector('img').src=link.href;dialog.showModal();
        }));
        dialog.querySelector('[data-wp26-close]').addEventListener('click',()=>dialog.close());
        dialog.addEventListener('click',event=>{if(event.target===dialog)dialog.close();});
      }
    });
    root.querySelectorAll('[data-wp26-play]').forEach(button=>{
      if(button.dataset.ready)return;button.dataset.ready='true';
      const video=button.parentElement.querySelector('video');
      if(!video)return;
      video.controls=false;
      const start=()=>{video.play().catch(()=>{button.hidden=false;video.controls=false;});};
      button.addEventListener('click',start);
      video.addEventListener('click',()=>{if(!video.controls)start();});
      video.addEventListener('play',()=>{button.hidden=true;video.controls=true;});
      video.addEventListener('ended',()=>{video.controls=false;button.hidden=false;});
    });
    root.querySelectorAll('.wp26-localization').forEach(form=>{
      if(form.dataset.autoSubmit)return;form.dataset.autoSubmit='true';
      form.addEventListener('change',event=>{
        if(event.target.matches('select'))form.requestSubmit();
      });
    });
    root.querySelectorAll('.wp26-mobile-menu').forEach(menu=>{
      if(menu.dataset.ready)return;menu.dataset.ready='true';
      menu.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>menu.open=false));
      menu.addEventListener('keydown',event=>{if(event.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}});
      document.addEventListener('click',event=>{if(!menu.contains(event.target))menu.open=false;});
    });
  }
  init();document.addEventListener('shopify:section:load',event=>init(event.target));
})();

